import { HttpClient, JsonpClientBackend } from '@angular/common/http';
import { EventEmitter, Injectable, Output } from '@angular/core';
import { AppData } from 'src/app/app.data';
import { AppSettings } from 'src/app/app.settings';
import { Settings } from 'src/app/app.settings.model';
import { Utils } from '../utils';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs/operators';
import { ApiResponseCode, EntityTypes, FileUploadType } from '../enums';
import { Guid } from '../models/guid';
import { Observable } from 'rxjs';





@Injectable({
  providedIn: 'root'
})
export class FileUploadService {

  //
  //   USE THIS SERVICE TO LOAD DOCUMENTS
  //


  CUSTOMER_DOCUMENT_TYPE_DOCUMENT = 0;
  CUSTOMER_DOCUMENT_TYPE_IMAGE = 1;

  settings: Settings;
  apiEndPoint: string = Utils.getApiEndPoint(); // environment.APIEndpoint;  
  customerID: number;
  files: any[] = [];      // files to upload 
  imgFileTypes = ["png", "jpg", "jpeg", "bmp", "svg", "tiff", "gif"];
  thumbWidth = 240;
  thumbHeight = 170;
  maxFileSize = 20971520; // 20mb
  chunkSize = 524288; // 0.5mb  
  abortImageSave = false;
  error: string;
  


  @Output() onProgress: EventEmitter<any> = new EventEmitter<any>();
  @Output() onComplete: EventEmitter<any> = new EventEmitter<any>();




  constructor(private http: HttpClient,
    private appSettings: AppSettings,
    private appData: AppData,
    private translate: TranslateService) {

    this.settings = appSettings.settings;
  }

  //
  // -------------> USE file-upload2-service <--------------
  //
  // startUploadImage(event: any, customerID: number) {
    
  //   this.customerID = customerID;
  //   this.files = event.currentTarget.files || [];

  //   //
  //   // prepare data to register files to upload by chunks
  //   //
  //   if (this.files && this.files.length > 0) {

  //     for (let index = 0; index < this.files.length; index++) {
  //       let file = this.files[index];
  //       file.uid = Guid.newGuid();
  //       // build register data
  //       file.registerData = {
  //         customerID: this.customerID,
  //         entityID: this.customerID,
  //         entityType: EntityTypes.Customer,
  //         description: '',
  //         customerDocumentType: this.CUSTOMER_DOCUMENT_TYPE_IMAGE,
  //         fileName: file.name,
  //         fileUID: file.uid,
  //         fileSize: file.size,
  //         width: 0,
  //         height: 0,
  //         readyToBeSend: false
  //       }
  //     }

  //     this.prepareImagesAndRegisterFileForUpload();

  //   }

  // }

  startUploadDocument(event: any, customerID: number, departmentID: number, entityID: number, entityType: EntityTypes){    
    this.customerID = customerID;
    var currentFiles = (event.currentTarget && event.currentTarget.files) ||
      (event.target && event.target.files) ||
      [];

      this.files = currentFiles;

    //
    // prepare data to register files to upload by chunks
    //
    if (currentFiles && currentFiles.length > 0) {

      for (let index = 0; index < currentFiles.length; index++) {
        let file = this.files[index];
        //this.files.push(file);

       // file.uid = Guid.newGuid(); // we set uid earlier for the porpose of show progress
        // build register data
        file.registerData = {
          customerID: customerID,
          entityID: entityID,
          entityType: entityType,
          departmentID: departmentID,
          description: '',
          customerDocumentType: this.CUSTOMER_DOCUMENT_TYPE_DOCUMENT,
          fileName: file.name,
          fileUID: file.uid,
          fileSize: file.size,
          width: 0,
          height: 0,
          readyToBeSend: false
        }
      }
     
      this.prepareDocumentsAndRegisterFileForUpload();
    }
  }

  private prepareDocumentsAndRegisterFileForUpload() {
   
    for (let index = 0; index < this.files.length; index++) {
      let file = this.files[index];
      var reader = new FileReader();
      reader.onload = (e: any) => {
        
        file.registerData.readyToBeSend = true;
        let fullImageData = e.target.result;
        let imageData = fullImageData.split(',')[1]; // get base64 data after "data:image/png;base64,"   
        file.imageData = imageData;
        file.imageDataLength = imageData.length;
        file.imageDataShift = 0;
        file.chunkID = 0;
        file.imageDataChunkSize = this.chunkSize;

        if (Array.from(this.files).filter(x => x.registerData.readyToBeSend).length === this.files.length) {
          this.registerFiles(); // ==> Register
        }
      };

      reader.onerror = (e: any) => {
        
        console.error(`Error occurred reading file: ${file.name}`);
      };

      // this read the file
      reader.readAsDataURL(file);
    }
  }

  private prepareImagesAndRegisterFileForUpload() {
    // Fill the real image width, height, and get the raw data      
    for (let index = 0; index < this.files.length; index++) {
      let file = this.files[index];

      var reader = new FileReader();
      reader.onload = (e: any) => {

        const image = new Image();
        image.src = e.target.result;

        image.onload = rs => {
          file.registerData.width = rs.currentTarget['width'];
          file.registerData.height = rs.currentTarget['height'];
          file.registerData.readyToBeSend = true;

          // get files data, length, width and hight
          let fullImageData = e.target.result;
          let imageData = fullImageData.split(',')[1]; // get base64 data after "data:image/png;base64,"         
          file.imageData = imageData;
          file.imageDataLength = imageData.length;
          file.imageDataShift = 0;
          file.chunkID = 0;
          file.imageDataChunkSize = this.chunkSize;


          if (Array.from(this.files).filter(x => x.registerData.readyToBeSend).length === this.files.length) {
            this.registerFiles(); // ==> Register
          }

        };

        image.onerror = (err) => {
          // somthing wrong but try load image anyway      
          file.registerData.width = 0;
          file.registerData.height = 0;
          file.registerData.readyToBeSend = true;
          file.error = err;

          this.onComplete.emit({ error: err });
        };
      }

      // this read the file
      reader.readAsDataURL(file);

    }
  }

  private registerFiles() {
    console.log('start register files...');
    this.filesRegistration().subscribe(result => {      
      if (result.Code == ApiResponseCode.Success) {
        console.log('file registered');
        this.startUploadChunks();
      }
      else {
        var filesData = Array.from(this.files).filter(x => x.registerData);
        console.log('failed registered files' + JSON.stringify(filesData));

        this.error = result.Error || this.translate.instant(`ERROR.CODE.${result.Code}`);
        this.onComplete.emit({ action: 'register', error: this.error });
      }
    }, error => {
      
      this.error = error;
      this.onComplete.emit({ action: 'register', error: error });
    })
  }


  private filesRegistration() {
    var data = Array.from(this.files).map(x => x.registerData);
    return this.http.post<any>(this.apiEndPoint + `UploadApi/RegisterFiles`, JSON.stringify(data))
      .pipe(map(result => {
        return result;
      }));
  }


  private startUploadChunks() {

    console.log('start upload chunks');

    for (let index = 0; index < this.files.length; index++) {
      if (this.abortImageSave) {
        this.onComplete.emit({ action: 'aborted', error: 'aborted' });
        break;
      }
      const file = this.files[index];
      this.uploadChunk(file.uid);
    }
  }

  private uploadChunk(fileUID) {

    console.log('uploadChunk: ' + fileUID);

    const file = Array.from(this.files).filter(x => x.uid === fileUID)[0];
    file.lastChank = false;
    var dataForSend;

    if (this.abortImageSave) {
      this.onComplete.emit({ action: 'aborted', error: 'aborted', fileUID: fileUID });
      return;
    }

    if (file.imageDataShift >= file.imageDataLength) {
      this.finishUploadChunk(file.uid); // ==> finish upload image
      return;
    }

    // continue upload by chunks                
    if (file.imageDataLength - file.imageDataShift > file.imageDataChunkSize) {
      dataForSend = file.imageData.slice(file.imageDataShift, file.imageDataShift + file.imageDataChunkSize);
      file.imageDataShift += file.imageDataChunkSize;

    }
    else { // send last bytes                    
      dataForSend = file.imageData.slice(file.imageDataShift);
      file.imageDataShift = file.imageDataLength;
      file.lastChunk = true;
    }
    ++file.chunkID;

    var packet = {
      ChunkID: file.chunkID,
      Guid: file.uid,
      Data: dataForSend,
      LastChunk: file.lastChunk
    };

    this.postChunk(packet).subscribe(result => {
      
      
      var uid = result.Data.Guid;
      var chunkID = result.Data.ChunkID;
      var currentFile = Array.from(this.files).filter(f => f.uid === uid)[0];
     
      if(result.Error){        
        currentFile.error = result.Error;
        this.onProgress.emit( {action: 'postChunk', fileUID: uid, error: result.Error});
      }
      else{
        var progress = Math.round(file.imageDataShift / currentFile.imageDataLength * 100);
        console.log(`progress: ${progress}%, uid: ${uid}, totalFileLength: ${currentFile.imageDataLength}, totalSent: ${file.imageDataShift}`);
        
        this.onProgress.emit({ fileUID: uid, progress: progress, totalFileLength: currentFile.imageDataLength, sent: file.imageDataShift });
        this.uploadChunk(uid); // upload next chunk.
      }

      
    },
      error => {
        this.error = error;
        this.onComplete.emit({ action: 'postChunk', error: error });
      });

  }



  finishUploadChunk(fileUID: string) {
    
    if (this.abortImageSave) {  
      let file = this.files.filter(x=> x.fileUID === fileUID)[0];    
      this.onComplete.emit( { action: 'aborted', file: file });
      return;
    }

    this.postFinish(fileUID).subscribe(result => {
      
      var guid = result.Data.FileUID;
      if (result.Code == ApiResponseCode.Success) {
        let file = Array.from(this.files).filter(x => x.uid === fileUID)[0];
        file.finished = true;

        if (Array.from(this.files).filter(x => x.finished).length === this.files.length) {
          this.onComplete.emit({ action: 'complete', fileUID: fileUID });
        }

      }
      else {
        let file = Array.from(this.files).filter(x => x.uid === fileUID)[0];
        this.error = result.Error || this.translate.instant(`ERROR.CODE.${result.Code}`);
        this.onComplete.emit({ action: 'postFinish', error: this.error, fileUID: fileUID });
      }
    }, error => {
      let file = Array.from(this.files).filter(x => x.uid === fileUID)[0];
      this.error = error;
      this.onComplete.emit({ action: 'postFinish', error: this.error, fileUID: fileUID });
    })

  }

  postChunk(packet: any) {

    console.log('post chunk: ' + JSON.stringify({ Guid: packet.Guid, ChunkID: packet.ChunkID }));

    return this.http.post<any>(this.apiEndPoint + `UploadApi/UploadChunk`, JSON.stringify(packet))
      .pipe(map(result => {
        return result;
      }));
  }

  postFinish(fileUID: string) {

    console.log('post finish file uid: ' + fileUID);

    return this.http.get<any>(this.apiEndPoint + `UploadApi/FinishUploadChunk/${fileUID}`)
      .pipe(map(result => {
        return result;
      }));
  }


}
